import script from "./Cookies_policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Cookies_policy.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__